// extracted by mini-css-extract-plugin
export default {"landscapeAboutContactPersonsWrapper":"LandscapeAboutContactPersonsPage_landscapeAboutContactPersonsWrapper__MShxA"};